export default async (logOut) => {
  logOut();

  const isFBUserExist = window?.FB?.getAccessToken();

  if (isFBUserExist) {
    window.FB.logout();
  }
};
